import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  Leri: {
    id: 'label_image_and_text',
    defaultMessage: 'Image and text',
  },
  Items: {
    id: 'label_items',
    defaultMessage: 'Items',
  },
  Item: {
    id: 'label_item',
    defaultMessage: 'Item',
  },
  AddItem: {
    id: 'label_add_item',
    defaultMessage: 'Add item',
  },
  Title: {
    id: 'label_title',
    defaultMessage: 'Title',
  },
  Media: {
    id: 'label_media',
    defaultMessage: 'Media',
  },
  Actions: {
    id: 'label_actions',
    defaultMessage: 'Actions',
  },
});
